import React from "react";
import { DashboardConfig } from "../components/features/Dashboard/DashboardConfig/DashboardConfig";

export const DashboardConfigScreen = () => {
    return <DashboardConfig/>;
}